import { API_CALL } from 'actions/actionConstants'
import { FETCH_WRAPPED } from 'actions/apiActionConstants'
import { getMyWrapped } from 'api/wrapped/wrapped'
import { AppAction } from './types/ActionTypes'

export function fetchWrapped(): AppAction {
  return async(dispatch, getState) => {
    const state = getState()
    const wrappedState = state.wrapped

    // Skip if already fetching or fetched
    if (wrappedState.state === 'loading' || wrappedState.state === 'done') {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_WRAPPED,
      request: () => getMyWrapped(),
    })
  }
}
